import { ApolloClient, ApolloProvider as ApolloProviderWrapper } from '@apollo/client';
import React, { ReactNode } from 'react';

interface ApolloProviderWrapperProps {
	client: ApolloClient<any>;
	children: ReactNode;
}

export const ApolloProvider: React.FC<ApolloProviderWrapperProps> = ({ client, children }) => (
	<ApolloProviderWrapper client={client}>{children}</ApolloProviderWrapper>
);
